// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BMtS","footer":"styles_footer__1m6CN","passCodeTooltip":"styles_passCodeTooltip__rce5q"};